<template>
    <div class="px-4 py-4 md:px-8 md:py-6">
        <slot> </slot>
    </div>
</template>
